module.exports = __webpack_public_path__ + "img/public/SiteIcons/saveCalenderClose.svg?7198e819";